import { useAuth } from "@/contexts/AuthContext";

/** Renders children only when current user's role is in `roles`. */
export function RoleGate({ roles, children, fallback = null }) {
  const { user } = useAuth();
  if (!user) return fallback;
  if (!roles || roles.length === 0) return children;
  return roles.includes(user.role) ? children : fallback;
}

export function useHasRole(...roles) {
  const { user } = useAuth();
  if (!user) return false;
  return roles.includes(user.role);
}
